export function ShieldIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 18 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8.30201 20.5469C8.5234 20.676 8.6341 20.7406 8.79032 20.7741C8.91156 20.8001 9.08844 20.8001 9.20968 20.7741C9.3659 20.7406 9.4766 20.676 9.69799 20.5469C11.646 19.4104 17 15.8404 17 10.932V6.1496C17 5.35009 17 4.95033 16.8692 4.6067C16.7537 4.30314 16.566 4.03228 16.3223 3.81753C16.0465 3.57444 15.6722 3.43408 14.9236 3.15335L9.5618 1.14267C9.3539 1.06471 9.24995 1.02573 9.14302 1.01028C9.04816 0.996573 8.95184 0.996573 8.85698 1.01028C8.75005 1.02573 8.6461 1.06471 8.4382 1.14267L3.0764 3.15335C2.3278 3.43408 1.9535 3.57444 1.67766 3.81753C1.43398 4.03228 1.24627 4.30314 1.13076 4.6067C1 4.95033 1 5.35009 1 6.1496V10.932C1 15.8404 6.35396 19.4104 8.30201 20.5469Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
